import { createStyles } from "@material-ui/core/styles";
import { BorderBottom } from "@material-ui/icons";
import { BACKGROUND_COLOR } from "constants/colors";
import { cold } from "react-hot-loader";

export const styles = () =>
  createStyles({
    root: {
      backgroundColor: BACKGROUND_COLOR,
      width: "100%",
      height: "100%",
      padding: "0",
      margin: "0",
    },
    customTab:{
      display:"flex",
      margin:"10px 0px"
    },

    customButton:{
      width:"50%",
      backgroundColor:"transparent",
      fontSize:"15px",
      outline:"0",
      color:"grey",
      fontWeight:"bold",
      textTransform:"capitalize",
      borderBottom:"3px solid black",
   
    },

    activeCustomButton:{
      width:"50%",
      backgroundColor:"transparent",
      fontSize:"15px",
      outline:"0",
      color:"white",
      textTransform:"capitalize",
      fontWeight:"bold",
      borderBottom:"3px solid #90caf9",
      borderRadius:"0px"
    }
  });
